import React from "react";
import { useSelector } from "react-redux";
import CustomTable from "../../../blueplanitUtils/CustomTabels";
import { FamilyModelPopup } from "../../../components/ProfileEditpopUp/FamilyInfoModelPopUp";
import EmergencyContacts from "./emergencyContact";
import AddNoteBox from "./addNote";
import PersonalInformationModelPopup from "../../../components/modelpopup/PersonalInformationModelPopup";

const FamilyInfo = () => {
  const familyInfoData = useSelector((state) => state.employee.familyMembers) || [];

  const familyColumns = ["Name", "Relationship", "Date of Birth", "Age", "Dependent"];
  const familyLabels = ["name", "relationship", "dob", "age", "dependent"];
  const dateFieldsMap = { dob: true };

  return (
    <>
      <CustomTable
        title="Family Information"
        data={familyInfoData}
        columns={familyColumns}
        dataLabel={familyLabels}
        Id="family_info_modal"
        dateFieldsMap={dateFieldsMap}
      />
      <FamilyModelPopup />
      <EmergencyContacts />
      <AddNoteBox name={"familyNote"} />
      <PersonalInformationModelPopup name={"familyNote"} />
    </>
  );
};

export default FamilyInfo;
